import { Box, Grid, Stack, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GlobalButton from "../../../components/CustomButton";
import DashboardStatus from "../../../components/Dashboard/DashboardStatus";
import CustomRangePicker from "../../../components/DateRangePicker";
import Label from "../../../components/Label";
import Loader from "../../../components/Loader";
import NavigationDrawer from "../../../components/NavigationDrawer";
import SnackbarAlert from "../../../components/SnackBar";
import appcolors from "../../../constants/Colors";
import { fetchDashboardData } from "../../../services/Dashboard";
import AppointmentActivity from "./AppointmentActivity";
import MainChart from "./MainChart";
import TodaysAppointments from "./TodaysAppointments";
import TopMembesrGraph from "./TopMembersGraph";
import TopServicesTable from "./TopServicesTable";
import WelcomeDialog from "./WelcomeDialog";

function ClientDashboard() {
  const welcomeDialogRef = useRef(null);
  const navigate = useNavigate();
  const { userPro } = useSelector((state) => state.userProSlice);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);

  const currentYear = moment().year();
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [endDate, setEndDate] = useState(moment(`${currentYear}-12-31`));
  const [startDate, setStartDate] = useState(moment(`${currentYear}-01-01`));
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    if (selectedBranch) {
      handleFetchDashboardData();
    }
  }, [selectedBranch]);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleFetchDashboardData = async () => {
    try {
      let payload = {
        branchId: selectedBranch,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
      };
      setIsLoading(true);
      const responce = await fetchDashboardData(payload);
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        let data = responce?.data?.data;
        setDashboardData(data);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error, "errorerrorerrorerrorerror");
      handleSnackbarVal(true, "error", error?.data?.message);
    }
  };

  const handleDatesChange = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  if (!userPro) {
    navigate("/profile-update/steps", { replace: true });
  }

  return (
    <NavigationDrawer>
      <Typography
        variant="h3"
        fontSize={"1.125rem"}
        fontWeight={600}
        color={appcolors.gunmetal}
      >
        Welcome LOBA DESK
      </Typography>

      <Stack
        mt={3}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <DashboardStatus />
        <Stack direction={"row"} alignItems={"center"}>
          <Box mr={3}>
            <Label labelText="Select Date" />
            <Stack>
              <CustomRangePicker
                stackProps={{
                  boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
                  borderRadius: "6px",
                }}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                handleDatesChange={handleDatesChange}
              />
            </Stack>
          </Box>

          <Box height={40} mt={3}>
            <GlobalButton
              variant={"contained"}
              btnText={"Search"}
              handleClickBtn={handleFetchDashboardData}
              styleProps={{
                fontWeight: 400,
                width: 100,
                fontSize: "0.875rem",
              }}
            />
          </Box>
        </Stack>
      </Stack>

      <Grid container mt={2} spacing={2}>
        <Grid item xs={12} md={12}>
          <MainChart data={dashboardData?.mainChart || []} />
        </Grid>
        <Grid item xs={12} md={12}>
          <TodaysAppointments data={dashboardData?.todaysAppointments || []} />
        </Grid>
        <Grid item xs={12} md={12}>
          <AppointmentActivity
            data={dashboardData?.upcomingAppointments || []}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TopServicesTable data={dashboardData?.topServices || []} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TopMembesrGraph data={dashboardData?.topTeamMembers || []} />
        </Grid>
      </Grid>
      <WelcomeDialog ref={welcomeDialogRef} />
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
    </NavigationDrawer>
  );
}

export default ClientDashboard;
